import { useState, useEffect } from "react";

const useMousePosition = () => {
    const [mousePosition, setMousePosition] = useState({ x: -100, y: -100 });
    const updateMousePosition = (e:any) => {
        setMousePosition({ x: e.clientX, y: e.clientY });
    };
    
    useEffect(() => {
        window.addEventListener("mousemove", updateMousePosition);
        return () => window.removeEventListener("mousemove", updateMousePosition);
    }, []);
    
    return mousePosition;
};

export default useMousePosition;